<app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>

<div class="grid grid-cols-1 gap-6">
  <app-component-card [title]="pageTitle" desc="Complete los datos de la regla de ciclo">

    <!-- Loading -->
    @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando datos...</span>
    </div>
    }

    <!-- Error -->
    @if (error) {
    <div class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
    }

    @if (!loading) {
    <form (ngSubmit)="guardar()" #ruleForm="ngForm" class="space-y-5">

      <!-- Ciclo y Atributo en 2 columnas -->
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <!-- Ciclo de Contacto -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Ciclo de Contacto <span class="text-error-500">*</span>
          </label>
          <select
            name="idContactCycle"
            #cycleField="ngModel"
            [(ngModel)]="idContactCycle"
            required
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <option [ngValue]="null">Seleccione un ciclo</option>
            @for (ciclo of ciclos; track ciclo.id) {
            <option [ngValue]="ciclo.id">{{ ciclo.name }}</option>
            }
          </select>
          @if (loadingCiclos) {
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Cargando ciclos...</p>
          }
          @if (cycleField.invalid && (cycleField.dirty || cycleField.touched)) {
          <p class="mt-1 text-xs text-error-500">Seleccione un ciclo de contacto.</p>
          }
        </div>

        <!-- Atributo de Contacto -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Atributo de Contacto <span class="text-error-500">*</span>
          </label>
          <select
            name="idContactAttribute"
            #attributeField="ngModel"
            [(ngModel)]="idContactAttribute"
            required
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <option [ngValue]="null">Seleccione un atributo</option>
            @for (attr of atributos; track attr.id) {
            <option [ngValue]="attr.id">{{ attr.displayName }}</option>
            }
          </select>
          @if (loadingAtributos) {
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Cargando atributos...</p>
          }
          @if (attributeField.invalid && (attributeField.dirty || attributeField.touched)) {
          <p class="mt-1 text-xs text-error-500">Seleccione un atributo de contacto.</p>
          }
        </div>
      </div>

      <!-- Tipo de Operación -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Tipo de Operación
        </label>
        <select
          name="operationType"
          [(ngModel)]="operationType"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <option value="SET">SET — Asignar valor fijo</option>
          <option value="INCREMENT">INCREMENT — Incrementar valor</option>
          <option value="COPY_FROM_FIELD">COPY_FROM_FIELD — Copiar desde otro campo</option>
        </select>
      </div>

      <!-- Expresión de Valor -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Expresión de Valor <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          name="valueExpression"
          #valueField="ngModel"
          [(ngModel)]="valueExpression"
          required
          [placeholder]="valueExpressionHint"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed font-mono"
        />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ valueExpressionHint }}</p>
        @if (valueField.invalid && (valueField.dirty || valueField.touched)) {
        <p class="mt-1 text-xs text-error-500">La expresión de valor es obligatoria.</p>
        }
      </div>

      <!-- Orden de Ejecución y Estado -->
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <!-- Orden de Ejecución -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Orden de Ejecución <span class="text-error-500">*</span>
          </label>
          <input
            type="number"
            name="executionOrder"
            #orderField="ngModel"
            [(ngModel)]="executionOrder"
            required
            min="1"
            step="1"
            placeholder="1"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Orden en que se ejecuta esta regla</p>
          @if (orderField.invalid && (orderField.dirty || orderField.touched)) {
          <p class="mt-1 text-xs text-error-500">Indique un orden de ejecución mayor o igual a 1.</p>
          }
        </div>

        <!-- Estado -->
        <div class="flex items-start gap-3 pt-2 sm:pt-7">
          <input
            type="checkbox"
            name="isActive"
            [(ngModel)]="isActive"
            id="isActive"
            class="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800"
          />
          <div>
            <label for="isActive" class="text-sm font-medium text-gray-700 dark:text-gray-300">
              Regla activa
            </label>
            <p class="text-xs text-gray-500 dark:text-gray-400">
              Si está desmarcado, la regla no se ejecutará
            </p>
          </div>
        </div>
      </div>

      <!-- Botones -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button
          variant="outline"
          type="button"
          (btnClick)="cancelar()"
        >
          Cancelar
        </app-button>
        <app-button
          variant="primary"
          type="submit"
          [disabled]="saving"
        >
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear Regla') }}
        </app-button>
      </div>
    </form>
    }
  </app-component-card>
</div>
